import type { PixelFrame } from "pixelfx";
import type { ClipName, HeroAtlas } from "./atlas";
import type { Shot } from "./animation";

/** Нарисовать кадр захвата движений в кадр арта: стопы в (x, y), лицом по facing; невидимка — редкое мерцание. */
export function drawSprite(
  frame: PixelFrame,
  mask: Uint8Array,
  atlas: HeroAtlas,
  shot: Shot,
  x: number,
  y: number,
  facing: number,
  side: number,
  invisible: boolean,
  tick: number,
): boolean {
  const clip = atlas.get(shot.clip as ClipName);
  const sprite = clip?.frames[Math.max(0, Math.min(clip.frames.length - 1, Math.floor(shot.frame)))];
  if (!clip || !sprite) return false;
  for (let row = 0; row < sprite.h; row++) {
    const sy = y + sprite.oy + row;
    if (sy < 0 || sy >= frame.h) continue;
    for (let column = 0; column < sprite.w; column++) {
      const color = clip.pixels[(sprite.y + row) * clip.width + sprite.x + column] ?? 0;
      if (color >>> 24 < 128) continue;
      const offset = sprite.ox + column;
      const sx = facing > 0 ? x + offset : x - offset - 1;
      if (sx < 0 || sx >= frame.w) continue;
      if (invisible) {
        if ((column + row + tick) % 9 === 0) frame.color[sy * frame.w + sx] = 0x60ffe0c0;
        continue;
      }
      frame.color[sy * frame.w + sx] = color;
      mask[sy * frame.w + sx] = side + 1;
    }
  }
  return true;
}
